<template>
  <b-modal
    id="responsive-modal"
    v-model="show"
    :size="size"
    hide-header
    hide-footer
    centered
  >
    <div class="overflow-y-scroll fit-scroll-content p-4 pt-3">
      <div class="d-flex justify-content-between">
        <span class="modal-title"> Integração {{ title }} </span>
        <button class="btn btn-sm" @click="close">
          <i class="fa fa-close text-secondary fs-18 font-weight-normal" />
        </button>
      </div>
      <a :href="link" v-if="link" target="_blank" class="text-primary-700">
        Conheça a {{ title }}
        <i class="fa fa-arrow-up-right-from-square text-primary-700" />
      </a>
      <slot>
        <component :is="content" @close="close" class="mt-5" />
      </slot>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    size: {
      type: String,
      default: "lg"
    },
    title: String,
    content: Object,
    link: String
  },
  data() {
    return {
      show: this.value
    };
  },
  methods: {
    close() {
      this.show = false;
    }
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit("input", val);
    }
  }
};
</script>
<style lang="scss" scoped>
.fit-scroll-content {
  overflow-x: hidden;
  max-height: 700px;
  @media screen and (max-width: 991px) {
    max-height: 600px;
  }
  ::v-deep {
    a {
      font-size: 14px;
      color: #9955ffdd;
    }
    .form-group {
      padding: 0;
      margin-top: 16px;
      label {
        font-size: 12px;
        font-weight: 400;
        line-height: 20px;
        margin-bottom: 4px;
        color: #736d80;
      }
      .el-input__inner,
      .form-control {
        border: 1px solid #c4c0cc;
        min-height: 40px;
        height: 40px;
      }
      .show-error-icon {
        right: 15px;
        top: 37px;
      }
    }
    .submit-buttons {
      gap: 16px;
      display: flex;
      margin-top: 32px;
      justify-content: flex-end;
      @media screen and (max-width: 991px) {
        flex-direction: column;
      }
      .btn-secondary {
        order: 0;
        @media screen and (max-width: 991px) {
          order: 1;
        }
        border: none;
        color: #57586be0;
        background-color: rgba(119, 120, 142, 0.08) !important;
      }
      .btn-primary {
        order: 1;
        @media screen and (max-width: 991px) {
          order: 0;
        }
        border: none;
        background-color: #781effe0;
      }
    }
  }
}
@media (min-width: 576px) and (max-width: 991px) {
  ::v-deep .modal-dialog {
    max-width: 100%;
  }
}
</style>
